"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyLoginPwd = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var password_1 = require("../../model/password");
var service_1 = require("../../../library/base/service");
var VerifyLoginPwd = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(VerifyLoginPwd, _super);
    function VerifyLoginPwd() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '校验交易密码';
        _this.code = '101021';
        _this.desc = '校验交易密码';
        _this.requestParams = new password_1.VerifyLoginPwdRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return VerifyLoginPwd;
}(service_1.BaseService));
exports.VerifyLoginPwd = VerifyLoginPwd;
//# sourceMappingURL=verifyLoginPwd.js.map